<p>
	We're thrilled to introduce Tickrr V2! With the launch of V2, we have transformed Tickrr from a
	free social platform focused on stock market news into a suite of of advanced charts and market
	research tools.
</p>

<h2>Overview</h2>
<p>
	Thanks to your feedback, we've redesigned Tickrr to offer significantly more depth and
	functionality to help you invest smarter. Our new platform includes:
</p>

<h3>Advanced Charts</h3>
<p>
	We have designed a brand-new charting system from the ground up. You can use our charts to
	analyze over 20,000 different symbols, including stocks, cryptocurrencies, and a variety of
	other asset types. You can access real-time and historical data, apply a wide range of technical
	indicators (coming soon), and even create custom indicators (coming soon).
</p>
<p>
	Additionally, we are currently designing an entire suite of drawing tools for technical
	analysis, including trend lines, Fibonacci retracements, and more, which we expect to ship in
	the coming months.
</p>

<h3>Detailed Market Analysis</h3>
<p>
	Tickrr V2 offers in-depth market analysis tools beyond basic stock info. Access fundamental
	data, earnings reports, insider trading info (coming soon), and sector performance metrics
	(coming soon).
</p>

<!-- <h3>Comprehensive Research Tools</h3>
	<p>
		We've added a variety of research tools to give you a competitive edge. These include
		company profiles with key metrics, financial statement analysis, peer comparison tools
		(coming soon), and risk assessment features (coming soon).
	</p> -->

<h3>Stock Screener</h3>
<p>
	Tickrr V2 introduces a powerful stock screener that lets you filter stocks based on many
	criteria. Screen for stocks using fundamental metrics (like P/E ratio, market cap, dividend
	yield), company characteristics (such as sector, industry, and country), and more.
</p>

<h3>News Feeds</h3>
<p>
	We've kept our popular market news feed, where you can like, comment, and receive personalized
	news updates.
</p>

<h2>Premium Only</h2>
<p>
	Moving to a paid-only Premium model ensures we can deliver top-quality features and services for
	those who need the best in market research. This allows us to invest in cutting-edge technology,
	maintain high data accuracy, and provide responsive customer support. We believe the enhanced
	features in Tickrr V2 will help you make more informed investment decisions. Whether you're a
	day trader, long-term investor, or financial professional, Tickrr V2 offers the tools you need
	to stay ahead in today's markets.
</p>

<h2>Join now!</h2>
<p>
	Join us on this exciting journey as we continue to improve Tickrr. Stay tuned for updates,
	including tutorials on using our new features. Elevate your investing experience with Tickrr V2,
	available now!
</p>
